import { gnav } from "./functions/gnav.es6";
import { userAgent } from "./functions/useAgent.es6";

import ScrollFunc from "./classes/scrollfunc.es6";
import Movie from "./classes/movie.es6";
import Modal from "./classes/modal.es6";
import Slider from "./classes/slider.es6";

export default class Main {
    constructor() {
        this.screenHeight = 0;
        this.modal = new Modal();
        this.movie = new Movie();
        this.scrollfunc = new ScrollFunc();
        this.slider = new Slider();
        this.init();
    }

    init() {
        this.eventBind();

        //functions
        gnav();
        userAgent();

        //ready
        document.body.classList.add("-ready");
    }

    update() {
        this.screenHeight = window.innerHeight;
        document.documentElement.style.setProperty("--screenHeight", `${this.screenHeight}px`);
    }

    eventBind() {
        this.update();
        window.addEventListener("resize", this.update);
    }
}
